import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseHomeSlides() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetHomeSlides = (Search, myPC, SlideID, callback) => {
    MyAxios.get(`Admin_HomeSlide?w=${Search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC, AID: SlideID }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetHomeSlideById = (ID, callback) => {
    MyAxios.get(`Admin_HomeSlide/${ID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addSlide = (state, file1, file2, callback) => {
    state = toGregorianDate(state);
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file1) {
      data.append("Image1", file1);
    }
    if (file2) {
      data.append("Image2", file2);
    }
    MyAxios.post(`Admin_HomeSlide`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اسلاید با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updateSlide = (state, file1, file2, callback) => {
    state = toGregorianDate(state);

    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file1) {
      data.append("Image1", file1);
    }
    if (file2) {
      data.append("Image2", file2);
    }
    MyAxios.put(`Admin_HomeSlide`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اسلاید با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteSlide = (slideID, callback) => {
    const data = new FormData();
    data.append("slideID", slideID);
    MyAxios.delete(`Admin_HomeSlide`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اسلاید با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  function toGregorianDate(state) {
    let newObj = JSON.parse(JSON.stringify(state));

    if (newObj.startDate && newObj.startDate.charAt(0) == 1) {
      newObj.startDate = toGregorian(newObj.startDate);
    }

    if (newObj.endDate && newObj.endDate.charAt(0) == 1) {
      newObj.endDate = toGregorian(newObj.endDate);
    }
    return newObj;
  }

  const RotateHomepageSlides = (callback) => {
    MyAxios.post(`Admin_HomePage/RotateHomepageSlides`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetHomeSlides,
    GetHomeSlideById,
    addSlide,
    updateSlide,
    deleteSlide,
    RotateHomepageSlides,
  };
}
